import { render, staticRenderFns } from "./gridItemList.vue?vue&type=template&id=12f57af3&scoped=true&"
import script from "./gridItemList.vue?vue&type=script&lang=js&"
export * from "./gridItemList.vue?vue&type=script&lang=js&"
import style0 from "./gridItemList.vue?vue&type=style&index=0&id=12f57af3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f57af3",
  null
  
)

/* custom blocks */
import block0 from "./gridItemList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VIcon,VSelect,VTooltip})
